import { render, staticRenderFns } from "./ArtistShowsInformation.vue?vue&type=template&id=0103ea99&scoped=true"
import script from "./ArtistShowsInformation.vue?vue&type=script&lang=js"
export * from "./ArtistShowsInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0103ea99",
  null
  
)

export default component.exports